// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as Decco from "decco/src/Decco.bs.mjs";
import * as Js_dict from "rescript/lib/es6/js_dict.js";
import * as Js_json from "rescript/lib/es6/js_json.js";
import * as Js_array from "rescript/lib/es6/js_array.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Money$FeedSync from "./Money.bs.mjs";
import * as IdFunctor$FeedSync from "../IdFunctor.bs.mjs";

var Id = IdFunctor$FeedSync.Make({});

var ItemGroupId = IdFunctor$FeedSync.Make({});

function t_dirty_encode(v) {
  return Js_dict.fromArray([
              [
                "google_feed_id",
                Decco.optionToJson(Decco.stringToJson, v.google_feed_id)
              ],
              [
                "title",
                Decco.optionToJson(Decco.stringToJson, v.title)
              ],
              [
                "size",
                Decco.optionToJson(Decco.stringToJson, v.size)
              ],
              [
                "color",
                Decco.optionToJson(Decco.stringToJson, v.color)
              ],
              [
                "pattern",
                Decco.optionToJson(Decco.stringToJson, v.pattern)
              ],
              [
                "material",
                Decco.optionToJson(Decco.stringToJson, v.material)
              ],
              [
                "style",
                Decco.optionToJson(Decco.stringToJson, v.style)
              ],
              [
                "shape",
                Decco.optionToJson(Decco.stringToJson, v.shape)
              ],
              [
                "price",
                Decco.optionToJson(Decco.stringToJson, v.price)
              ],
              [
                "sale_price",
                Decco.optionToJson(Decco.stringToJson, v.sale_price)
              ],
              [
                "description",
                Decco.optionToJson(Decco.stringToJson, v.description)
              ],
              [
                "item_group_id",
                Decco.optionToJson(Decco.stringToJson, v.item_group_id)
              ],
              [
                "image_link",
                Decco.optionToJson(Decco.stringToJson, v.image_link)
              ],
              [
                "additional_image_link",
                Decco.optionToJson(Decco.stringToJson, v.additional_image_link)
              ],
              [
                "custom_label_0",
                Decco.optionToJson(Decco.stringToJson, v.custom_label_0)
              ],
              [
                "custom_label_1",
                Decco.optionToJson(Decco.stringToJson, v.custom_label_1)
              ],
              [
                "custom_label_2",
                Decco.optionToJson(Decco.stringToJson, v.custom_label_2)
              ],
              [
                "custom_label_3",
                Decco.optionToJson(Decco.stringToJson, v.custom_label_3)
              ],
              [
                "custom_label_4",
                Decco.optionToJson(Decco.stringToJson, v.custom_label_4)
              ],
              [
                "custom_label_5",
                Decco.optionToJson(Decco.stringToJson, v.custom_label_5)
              ],
              [
                "custom_label_6",
                Decco.optionToJson(Decco.stringToJson, v.custom_label_6)
              ],
              [
                "custom_label_7",
                Decco.optionToJson(Decco.stringToJson, v.custom_label_7)
              ],
              [
                "custom_label_8",
                Decco.optionToJson(Decco.stringToJson, v.custom_label_8)
              ],
              [
                "custom_label_9",
                Decco.optionToJson(Decco.stringToJson, v.custom_label_9)
              ],
              [
                "google_product_category",
                Decco.optionToJson(Decco.stringToJson, v.google_product_category)
              ],
              [
                "product_type",
                Decco.optionToJson(Decco.stringToJson, v.product_type)
              ],
              [
                "availability",
                Decco.optionToJson(Decco.stringToJson, v.availability)
              ],
              [
                "link",
                Decco.optionToJson(Decco.stringToJson, v.link)
              ],
              [
                "brand",
                Decco.optionToJson(Decco.stringToJson, v.brand)
              ],
              [
                "mpn",
                Decco.optionToJson(Decco.stringToJson, v.mpn)
              ],
              [
                "sku",
                Decco.optionToJson(Decco.stringToJson, v.sku)
              ],
              [
                "extensions",
                Decco.optionToJson((function (param) {
                        return Decco.dictToJson(Decco.stringToJson, param);
                      }), v.extensions)
              ]
            ]);
}

function t_dirty_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var google_feed_id = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "google_feed_id"), null));
  if (google_feed_id.TAG === /* Ok */0) {
    var title = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "title"), null));
    if (title.TAG === /* Ok */0) {
      var size = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "size"), null));
      if (size.TAG === /* Ok */0) {
        var color = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "color"), null));
        if (color.TAG === /* Ok */0) {
          var pattern = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "pattern"), null));
          if (pattern.TAG === /* Ok */0) {
            var material = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "material"), null));
            if (material.TAG === /* Ok */0) {
              var style = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "style"), null));
              if (style.TAG === /* Ok */0) {
                var shape = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "shape"), null));
                if (shape.TAG === /* Ok */0) {
                  var price = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "price"), null));
                  if (price.TAG === /* Ok */0) {
                    var sale_price = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "sale_price"), null));
                    if (sale_price.TAG === /* Ok */0) {
                      var description = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "description"), null));
                      if (description.TAG === /* Ok */0) {
                        var item_group_id = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "item_group_id"), null));
                        if (item_group_id.TAG === /* Ok */0) {
                          var image_link = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "image_link"), null));
                          if (image_link.TAG === /* Ok */0) {
                            var additional_image_link = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "additional_image_link"), null));
                            if (additional_image_link.TAG === /* Ok */0) {
                              var custom_label_0 = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "custom_label_0"), null));
                              if (custom_label_0.TAG === /* Ok */0) {
                                var custom_label_1 = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "custom_label_1"), null));
                                if (custom_label_1.TAG === /* Ok */0) {
                                  var custom_label_2 = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "custom_label_2"), null));
                                  if (custom_label_2.TAG === /* Ok */0) {
                                    var custom_label_3 = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "custom_label_3"), null));
                                    if (custom_label_3.TAG === /* Ok */0) {
                                      var custom_label_4 = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "custom_label_4"), null));
                                      if (custom_label_4.TAG === /* Ok */0) {
                                        var custom_label_5 = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "custom_label_5"), null));
                                        if (custom_label_5.TAG === /* Ok */0) {
                                          var custom_label_6 = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "custom_label_6"), null));
                                          if (custom_label_6.TAG === /* Ok */0) {
                                            var custom_label_7 = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "custom_label_7"), null));
                                            if (custom_label_7.TAG === /* Ok */0) {
                                              var custom_label_8 = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "custom_label_8"), null));
                                              if (custom_label_8.TAG === /* Ok */0) {
                                                var custom_label_9 = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "custom_label_9"), null));
                                                if (custom_label_9.TAG === /* Ok */0) {
                                                  var google_product_category = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "google_product_category"), null));
                                                  if (google_product_category.TAG === /* Ok */0) {
                                                    var product_type = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "product_type"), null));
                                                    if (product_type.TAG === /* Ok */0) {
                                                      var availability = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "availability"), null));
                                                      if (availability.TAG === /* Ok */0) {
                                                        var link = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "link"), null));
                                                        if (link.TAG === /* Ok */0) {
                                                          var brand = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "brand"), null));
                                                          if (brand.TAG === /* Ok */0) {
                                                            var mpn = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "mpn"), null));
                                                            if (mpn.TAG === /* Ok */0) {
                                                              var sku = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "sku"), null));
                                                              if (sku.TAG === /* Ok */0) {
                                                                var extensions = Decco.optionFromJson((function (param) {
                                                                        return Decco.dictFromJson(Decco.stringFromJson, param);
                                                                      }), Belt_Option.getWithDefault(Js_dict.get(dict$1, "extensions"), null));
                                                                if (extensions.TAG === /* Ok */0) {
                                                                  return {
                                                                          TAG: /* Ok */0,
                                                                          _0: {
                                                                            google_feed_id: google_feed_id._0,
                                                                            title: title._0,
                                                                            size: size._0,
                                                                            color: color._0,
                                                                            pattern: pattern._0,
                                                                            material: material._0,
                                                                            style: style._0,
                                                                            shape: shape._0,
                                                                            price: price._0,
                                                                            sale_price: sale_price._0,
                                                                            description: description._0,
                                                                            item_group_id: item_group_id._0,
                                                                            image_link: image_link._0,
                                                                            additional_image_link: additional_image_link._0,
                                                                            custom_label_0: custom_label_0._0,
                                                                            custom_label_1: custom_label_1._0,
                                                                            custom_label_2: custom_label_2._0,
                                                                            custom_label_3: custom_label_3._0,
                                                                            custom_label_4: custom_label_4._0,
                                                                            custom_label_5: custom_label_5._0,
                                                                            custom_label_6: custom_label_6._0,
                                                                            custom_label_7: custom_label_7._0,
                                                                            custom_label_8: custom_label_8._0,
                                                                            custom_label_9: custom_label_9._0,
                                                                            google_product_category: google_product_category._0,
                                                                            product_type: product_type._0,
                                                                            availability: availability._0,
                                                                            link: link._0,
                                                                            brand: brand._0,
                                                                            mpn: mpn._0,
                                                                            sku: sku._0,
                                                                            extensions: extensions._0
                                                                          }
                                                                        };
                                                                }
                                                                var e = extensions._0;
                                                                return {
                                                                        TAG: /* Error */1,
                                                                        _0: {
                                                                          path: ".extensions" + e.path,
                                                                          message: e.message,
                                                                          value: e.value
                                                                        }
                                                                      };
                                                              }
                                                              var e$1 = sku._0;
                                                              return {
                                                                      TAG: /* Error */1,
                                                                      _0: {
                                                                        path: ".sku" + e$1.path,
                                                                        message: e$1.message,
                                                                        value: e$1.value
                                                                      }
                                                                    };
                                                            }
                                                            var e$2 = mpn._0;
                                                            return {
                                                                    TAG: /* Error */1,
                                                                    _0: {
                                                                      path: ".mpn" + e$2.path,
                                                                      message: e$2.message,
                                                                      value: e$2.value
                                                                    }
                                                                  };
                                                          }
                                                          var e$3 = brand._0;
                                                          return {
                                                                  TAG: /* Error */1,
                                                                  _0: {
                                                                    path: ".brand" + e$3.path,
                                                                    message: e$3.message,
                                                                    value: e$3.value
                                                                  }
                                                                };
                                                        }
                                                        var e$4 = link._0;
                                                        return {
                                                                TAG: /* Error */1,
                                                                _0: {
                                                                  path: ".link" + e$4.path,
                                                                  message: e$4.message,
                                                                  value: e$4.value
                                                                }
                                                              };
                                                      }
                                                      var e$5 = availability._0;
                                                      return {
                                                              TAG: /* Error */1,
                                                              _0: {
                                                                path: ".availability" + e$5.path,
                                                                message: e$5.message,
                                                                value: e$5.value
                                                              }
                                                            };
                                                    }
                                                    var e$6 = product_type._0;
                                                    return {
                                                            TAG: /* Error */1,
                                                            _0: {
                                                              path: ".product_type" + e$6.path,
                                                              message: e$6.message,
                                                              value: e$6.value
                                                            }
                                                          };
                                                  }
                                                  var e$7 = google_product_category._0;
                                                  return {
                                                          TAG: /* Error */1,
                                                          _0: {
                                                            path: ".google_product_category" + e$7.path,
                                                            message: e$7.message,
                                                            value: e$7.value
                                                          }
                                                        };
                                                }
                                                var e$8 = custom_label_9._0;
                                                return {
                                                        TAG: /* Error */1,
                                                        _0: {
                                                          path: ".custom_label_9" + e$8.path,
                                                          message: e$8.message,
                                                          value: e$8.value
                                                        }
                                                      };
                                              }
                                              var e$9 = custom_label_8._0;
                                              return {
                                                      TAG: /* Error */1,
                                                      _0: {
                                                        path: ".custom_label_8" + e$9.path,
                                                        message: e$9.message,
                                                        value: e$9.value
                                                      }
                                                    };
                                            }
                                            var e$10 = custom_label_7._0;
                                            return {
                                                    TAG: /* Error */1,
                                                    _0: {
                                                      path: ".custom_label_7" + e$10.path,
                                                      message: e$10.message,
                                                      value: e$10.value
                                                    }
                                                  };
                                          }
                                          var e$11 = custom_label_6._0;
                                          return {
                                                  TAG: /* Error */1,
                                                  _0: {
                                                    path: ".custom_label_6" + e$11.path,
                                                    message: e$11.message,
                                                    value: e$11.value
                                                  }
                                                };
                                        }
                                        var e$12 = custom_label_5._0;
                                        return {
                                                TAG: /* Error */1,
                                                _0: {
                                                  path: ".custom_label_5" + e$12.path,
                                                  message: e$12.message,
                                                  value: e$12.value
                                                }
                                              };
                                      }
                                      var e$13 = custom_label_4._0;
                                      return {
                                              TAG: /* Error */1,
                                              _0: {
                                                path: ".custom_label_4" + e$13.path,
                                                message: e$13.message,
                                                value: e$13.value
                                              }
                                            };
                                    }
                                    var e$14 = custom_label_3._0;
                                    return {
                                            TAG: /* Error */1,
                                            _0: {
                                              path: ".custom_label_3" + e$14.path,
                                              message: e$14.message,
                                              value: e$14.value
                                            }
                                          };
                                  }
                                  var e$15 = custom_label_2._0;
                                  return {
                                          TAG: /* Error */1,
                                          _0: {
                                            path: ".custom_label_2" + e$15.path,
                                            message: e$15.message,
                                            value: e$15.value
                                          }
                                        };
                                }
                                var e$16 = custom_label_1._0;
                                return {
                                        TAG: /* Error */1,
                                        _0: {
                                          path: ".custom_label_1" + e$16.path,
                                          message: e$16.message,
                                          value: e$16.value
                                        }
                                      };
                              }
                              var e$17 = custom_label_0._0;
                              return {
                                      TAG: /* Error */1,
                                      _0: {
                                        path: ".custom_label_0" + e$17.path,
                                        message: e$17.message,
                                        value: e$17.value
                                      }
                                    };
                            }
                            var e$18 = additional_image_link._0;
                            return {
                                    TAG: /* Error */1,
                                    _0: {
                                      path: ".additional_image_link" + e$18.path,
                                      message: e$18.message,
                                      value: e$18.value
                                    }
                                  };
                          }
                          var e$19 = image_link._0;
                          return {
                                  TAG: /* Error */1,
                                  _0: {
                                    path: ".image_link" + e$19.path,
                                    message: e$19.message,
                                    value: e$19.value
                                  }
                                };
                        }
                        var e$20 = item_group_id._0;
                        return {
                                TAG: /* Error */1,
                                _0: {
                                  path: ".item_group_id" + e$20.path,
                                  message: e$20.message,
                                  value: e$20.value
                                }
                              };
                      }
                      var e$21 = description._0;
                      return {
                              TAG: /* Error */1,
                              _0: {
                                path: ".description" + e$21.path,
                                message: e$21.message,
                                value: e$21.value
                              }
                            };
                    }
                    var e$22 = sale_price._0;
                    return {
                            TAG: /* Error */1,
                            _0: {
                              path: ".sale_price" + e$22.path,
                              message: e$22.message,
                              value: e$22.value
                            }
                          };
                  }
                  var e$23 = price._0;
                  return {
                          TAG: /* Error */1,
                          _0: {
                            path: ".price" + e$23.path,
                            message: e$23.message,
                            value: e$23.value
                          }
                        };
                }
                var e$24 = shape._0;
                return {
                        TAG: /* Error */1,
                        _0: {
                          path: ".shape" + e$24.path,
                          message: e$24.message,
                          value: e$24.value
                        }
                      };
              }
              var e$25 = style._0;
              return {
                      TAG: /* Error */1,
                      _0: {
                        path: ".style" + e$25.path,
                        message: e$25.message,
                        value: e$25.value
                      }
                    };
            }
            var e$26 = material._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: ".material" + e$26.path,
                      message: e$26.message,
                      value: e$26.value
                    }
                  };
          }
          var e$27 = pattern._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".pattern" + e$27.path,
                    message: e$27.message,
                    value: e$27.value
                  }
                };
        }
        var e$28 = color._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".color" + e$28.path,
                  message: e$28.message,
                  value: e$28.value
                }
              };
      }
      var e$29 = size._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".size" + e$29.path,
                message: e$29.message,
                value: e$29.value
              }
            };
    }
    var e$30 = title._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".title" + e$30.path,
              message: e$30.message,
              value: e$30.value
            }
          };
  }
  var e$31 = google_feed_id._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".google_feed_id" + e$31.path,
            message: e$31.message,
            value: e$31.value
          }
        };
}

function t_encode(v) {
  return Js_dict.fromArray([
              [
                "id",
                Curry._1(Id.t_encode, v.id)
              ],
              [
                "title",
                Decco.optionToJson(Decco.stringToJson, v.title)
              ],
              [
                "size",
                Decco.optionToJson(Decco.stringToJson, v.size)
              ],
              [
                "color",
                Decco.optionToJson(Decco.stringToJson, v.color)
              ],
              [
                "pattern",
                Decco.optionToJson(Decco.stringToJson, v.pattern)
              ],
              [
                "material",
                Decco.optionToJson(Decco.stringToJson, v.material)
              ],
              [
                "style",
                Decco.optionToJson(Decco.stringToJson, v.style)
              ],
              [
                "shape",
                Decco.optionToJson(Decco.stringToJson, v.shape)
              ],
              [
                "price",
                Decco.optionToJson(Decco.stringToJson, v.price)
              ],
              [
                "sale_price",
                Decco.optionToJson(Decco.stringToJson, v.sale_price)
              ],
              [
                "description",
                Decco.optionToJson(Decco.stringToJson, v.description)
              ],
              [
                "item_group_id",
                Curry._1(ItemGroupId.t_encode, v.item_group_id)
              ],
              [
                "image_link",
                Decco.optionToJson(Decco.stringToJson, v.image_link)
              ],
              [
                "additional_image_link",
                Decco.optionToJson(Decco.stringToJson, v.additional_image_link)
              ],
              [
                "custom_label_0",
                Decco.optionToJson(Decco.stringToJson, v.custom_label_0)
              ],
              [
                "custom_label_1",
                Decco.optionToJson(Decco.stringToJson, v.custom_label_1)
              ],
              [
                "custom_label_2",
                Decco.optionToJson(Decco.stringToJson, v.custom_label_2)
              ],
              [
                "custom_label_3",
                Decco.optionToJson(Decco.stringToJson, v.custom_label_3)
              ],
              [
                "custom_label_4",
                Decco.optionToJson(Decco.stringToJson, v.custom_label_4)
              ],
              [
                "custom_label_5",
                Decco.optionToJson(Decco.stringToJson, v.custom_label_5)
              ],
              [
                "custom_label_6",
                Decco.optionToJson(Decco.stringToJson, v.custom_label_6)
              ],
              [
                "custom_label_7",
                Decco.optionToJson(Decco.stringToJson, v.custom_label_7)
              ],
              [
                "custom_label_8",
                Decco.optionToJson(Decco.stringToJson, v.custom_label_8)
              ],
              [
                "custom_label_9",
                Decco.optionToJson(Decco.stringToJson, v.custom_label_9)
              ],
              [
                "google_product_category",
                Decco.optionToJson(Decco.stringToJson, v.google_product_category)
              ],
              [
                "product_type",
                Decco.optionToJson(Decco.stringToJson, v.product_type)
              ],
              [
                "sane_product_type",
                Decco.optionToJson((function (param) {
                        return Decco.arrayToJson(Decco.stringToJson, param);
                      }), v.sane_product_type)
              ],
              [
                "availability",
                Decco.optionToJson(Decco.stringToJson, v.availability)
              ],
              [
                "link",
                Decco.optionToJson(Decco.stringToJson, v.link)
              ],
              [
                "brand",
                Decco.optionToJson(Decco.stringToJson, v.brand)
              ],
              [
                "mpn",
                Decco.optionToJson(Decco.stringToJson, v.mpn)
              ],
              [
                "sku",
                Decco.optionToJson(Decco.stringToJson, v.sku)
              ],
              [
                "secondary__price",
                Decco.optionToJson(Decco.stringToJson, v.secondary__price)
              ],
              [
                "secondary__sale_price",
                Decco.optionToJson(Decco.stringToJson, v.secondary__sale_price)
              ],
              [
                "secondary__availability",
                Decco.optionToJson(Decco.stringToJson, v.secondary__availability)
              ],
              [
                "x_created_at",
                Decco.optionToJson(Decco.floatToJson, v.x_created_at)
              ],
              [
                "x_best_seller_rank",
                Decco.optionToJson(Decco.floatToJson, v.x_best_seller_rank)
              ],
              [
                "x_featured_rank",
                Decco.optionToJson(Decco.floatToJson, v.x_featured_rank)
              ],
              [
                "x_reviews_average",
                Decco.optionToJson(Decco.floatToJson, v.x_reviews_average)
              ],
              [
                "x_reviews_count",
                Decco.optionToJson(Decco.floatToJson, v.x_reviews_count)
              ],
              [
                "x_promo_text",
                Decco.optionToJson(Decco.stringToJson, v.x_promo_text)
              ],
              [
                "x_meta",
                Decco.optionToJson((function (param) {
                        return Decco.dictToJson(Decco.stringToJson, param);
                      }), v.x_meta)
              ],
              [
                "x_options",
                Decco.optionToJson((function (param) {
                        return Decco.dictToJson(Decco.stringToJson, param);
                      }), v.x_options)
              ],
              [
                "x_tags",
                Decco.optionToJson((function (param) {
                        return Decco.arrayToJson(Decco.stringToJson, param);
                      }), v.x_tags)
              ],
              [
                "x_quantity",
                Decco.optionToJson(Decco.floatToJson, v.x_quantity)
              ],
              [
                "x_market",
                Decco.optionToJson(Decco.stringToJson, v.x_market)
              ],
              [
                "x_alternative_markets",
                Decco.optionToJson((function (param) {
                        return Decco.dictToJson((function (v) {
                                      return v;
                                    }), param);
                      }), v.x_alternative_markets)
              ],
              [
                "x_last_modified_at",
                Decco.optionToJson(Decco.floatToJson, v.x_last_modified_at)
              ]
            ]);
}

function t_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var id = Curry._1(Id.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "id"), null));
  if (id.TAG === /* Ok */0) {
    var title = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "title"), null));
    if (title.TAG === /* Ok */0) {
      var size = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "size"), null));
      if (size.TAG === /* Ok */0) {
        var color = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "color"), null));
        if (color.TAG === /* Ok */0) {
          var pattern = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "pattern"), null));
          if (pattern.TAG === /* Ok */0) {
            var material = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "material"), null));
            if (material.TAG === /* Ok */0) {
              var style = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "style"), null));
              if (style.TAG === /* Ok */0) {
                var shape = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "shape"), null));
                if (shape.TAG === /* Ok */0) {
                  var price = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "price"), null));
                  if (price.TAG === /* Ok */0) {
                    var sale_price = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "sale_price"), null));
                    if (sale_price.TAG === /* Ok */0) {
                      var description = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "description"), null));
                      if (description.TAG === /* Ok */0) {
                        var item_group_id = Curry._1(ItemGroupId.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "item_group_id"), null));
                        if (item_group_id.TAG === /* Ok */0) {
                          var image_link = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "image_link"), null));
                          if (image_link.TAG === /* Ok */0) {
                            var additional_image_link = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "additional_image_link"), null));
                            if (additional_image_link.TAG === /* Ok */0) {
                              var custom_label_0 = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "custom_label_0"), null));
                              if (custom_label_0.TAG === /* Ok */0) {
                                var custom_label_1 = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "custom_label_1"), null));
                                if (custom_label_1.TAG === /* Ok */0) {
                                  var custom_label_2 = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "custom_label_2"), null));
                                  if (custom_label_2.TAG === /* Ok */0) {
                                    var custom_label_3 = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "custom_label_3"), null));
                                    if (custom_label_3.TAG === /* Ok */0) {
                                      var custom_label_4 = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "custom_label_4"), null));
                                      if (custom_label_4.TAG === /* Ok */0) {
                                        var custom_label_5 = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "custom_label_5"), null));
                                        if (custom_label_5.TAG === /* Ok */0) {
                                          var custom_label_6 = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "custom_label_6"), null));
                                          if (custom_label_6.TAG === /* Ok */0) {
                                            var custom_label_7 = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "custom_label_7"), null));
                                            if (custom_label_7.TAG === /* Ok */0) {
                                              var custom_label_8 = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "custom_label_8"), null));
                                              if (custom_label_8.TAG === /* Ok */0) {
                                                var custom_label_9 = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "custom_label_9"), null));
                                                if (custom_label_9.TAG === /* Ok */0) {
                                                  var google_product_category = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "google_product_category"), null));
                                                  if (google_product_category.TAG === /* Ok */0) {
                                                    var product_type = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "product_type"), null));
                                                    if (product_type.TAG === /* Ok */0) {
                                                      var sane_product_type = Decco.optionFromJson((function (param) {
                                                              return Decco.arrayFromJson(Decco.stringFromJson, param);
                                                            }), Belt_Option.getWithDefault(Js_dict.get(dict$1, "sane_product_type"), null));
                                                      if (sane_product_type.TAG === /* Ok */0) {
                                                        var availability = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "availability"), null));
                                                        if (availability.TAG === /* Ok */0) {
                                                          var link = Belt_Option.getWithDefault(Belt_Option.map(Js_dict.get(dict$1, "link"), (function (param) {
                                                                      return Decco.optionFromJson(Decco.stringFromJson, param);
                                                                    })), {
                                                                TAG: /* Ok */0,
                                                                _0: ""
                                                              });
                                                          if (link.TAG === /* Ok */0) {
                                                            var brand = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "brand"), null));
                                                            if (brand.TAG === /* Ok */0) {
                                                              var mpn = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "mpn"), null));
                                                              if (mpn.TAG === /* Ok */0) {
                                                                var sku = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "sku"), null));
                                                                if (sku.TAG === /* Ok */0) {
                                                                  var secondary__price = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "secondary__price"), null));
                                                                  if (secondary__price.TAG === /* Ok */0) {
                                                                    var secondary__sale_price = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "secondary__sale_price"), null));
                                                                    if (secondary__sale_price.TAG === /* Ok */0) {
                                                                      var secondary__availability = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "secondary__availability"), null));
                                                                      if (secondary__availability.TAG === /* Ok */0) {
                                                                        var x_created_at = Decco.optionFromJson(Decco.floatFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "x_created_at"), null));
                                                                        if (x_created_at.TAG === /* Ok */0) {
                                                                          var x_best_seller_rank = Decco.optionFromJson(Decco.floatFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "x_best_seller_rank"), null));
                                                                          if (x_best_seller_rank.TAG === /* Ok */0) {
                                                                            var x_featured_rank = Decco.optionFromJson(Decco.floatFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "x_featured_rank"), null));
                                                                            if (x_featured_rank.TAG === /* Ok */0) {
                                                                              var x_reviews_average = Decco.optionFromJson(Decco.floatFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "x_reviews_average"), null));
                                                                              if (x_reviews_average.TAG === /* Ok */0) {
                                                                                var x_reviews_count = Decco.optionFromJson(Decco.floatFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "x_reviews_count"), null));
                                                                                if (x_reviews_count.TAG === /* Ok */0) {
                                                                                  var x_promo_text = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "x_promo_text"), null));
                                                                                  if (x_promo_text.TAG === /* Ok */0) {
                                                                                    var x_meta = Decco.optionFromJson((function (param) {
                                                                                            return Decco.dictFromJson(Decco.stringFromJson, param);
                                                                                          }), Belt_Option.getWithDefault(Js_dict.get(dict$1, "x_meta"), null));
                                                                                    if (x_meta.TAG === /* Ok */0) {
                                                                                      var x_options = Decco.optionFromJson((function (param) {
                                                                                              return Decco.dictFromJson(Decco.stringFromJson, param);
                                                                                            }), Belt_Option.getWithDefault(Js_dict.get(dict$1, "x_options"), null));
                                                                                      if (x_options.TAG === /* Ok */0) {
                                                                                        var x_tags = Decco.optionFromJson((function (param) {
                                                                                                return Decco.arrayFromJson(Decco.stringFromJson, param);
                                                                                              }), Belt_Option.getWithDefault(Js_dict.get(dict$1, "x_tags"), null));
                                                                                        if (x_tags.TAG === /* Ok */0) {
                                                                                          var x_quantity = Decco.optionFromJson(Decco.floatFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "x_quantity"), null));
                                                                                          if (x_quantity.TAG === /* Ok */0) {
                                                                                            var x_market = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "x_market"), null));
                                                                                            if (x_market.TAG === /* Ok */0) {
                                                                                              var x_alternative_markets = Decco.optionFromJson((function (param) {
                                                                                                      return Decco.dictFromJson((function (v) {
                                                                                                                    return {
                                                                                                                            TAG: /* Ok */0,
                                                                                                                            _0: v
                                                                                                                          };
                                                                                                                  }), param);
                                                                                                    }), Belt_Option.getWithDefault(Js_dict.get(dict$1, "x_alternative_markets"), null));
                                                                                              if (x_alternative_markets.TAG === /* Ok */0) {
                                                                                                var x_last_modified_at = Decco.optionFromJson(Decco.floatFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "x_last_modified_at"), null));
                                                                                                if (x_last_modified_at.TAG === /* Ok */0) {
                                                                                                  return {
                                                                                                          TAG: /* Ok */0,
                                                                                                          _0: {
                                                                                                            id: id._0,
                                                                                                            title: title._0,
                                                                                                            size: size._0,
                                                                                                            color: color._0,
                                                                                                            pattern: pattern._0,
                                                                                                            material: material._0,
                                                                                                            style: style._0,
                                                                                                            shape: shape._0,
                                                                                                            price: price._0,
                                                                                                            sale_price: sale_price._0,
                                                                                                            description: description._0,
                                                                                                            item_group_id: item_group_id._0,
                                                                                                            image_link: image_link._0,
                                                                                                            additional_image_link: additional_image_link._0,
                                                                                                            custom_label_0: custom_label_0._0,
                                                                                                            custom_label_1: custom_label_1._0,
                                                                                                            custom_label_2: custom_label_2._0,
                                                                                                            custom_label_3: custom_label_3._0,
                                                                                                            custom_label_4: custom_label_4._0,
                                                                                                            custom_label_5: custom_label_5._0,
                                                                                                            custom_label_6: custom_label_6._0,
                                                                                                            custom_label_7: custom_label_7._0,
                                                                                                            custom_label_8: custom_label_8._0,
                                                                                                            custom_label_9: custom_label_9._0,
                                                                                                            google_product_category: google_product_category._0,
                                                                                                            product_type: product_type._0,
                                                                                                            sane_product_type: sane_product_type._0,
                                                                                                            availability: availability._0,
                                                                                                            link: link._0,
                                                                                                            brand: brand._0,
                                                                                                            mpn: mpn._0,
                                                                                                            sku: sku._0,
                                                                                                            secondary__price: secondary__price._0,
                                                                                                            secondary__sale_price: secondary__sale_price._0,
                                                                                                            secondary__availability: secondary__availability._0,
                                                                                                            x_created_at: x_created_at._0,
                                                                                                            x_best_seller_rank: x_best_seller_rank._0,
                                                                                                            x_featured_rank: x_featured_rank._0,
                                                                                                            x_reviews_average: x_reviews_average._0,
                                                                                                            x_reviews_count: x_reviews_count._0,
                                                                                                            x_promo_text: x_promo_text._0,
                                                                                                            x_meta: x_meta._0,
                                                                                                            x_options: x_options._0,
                                                                                                            x_tags: x_tags._0,
                                                                                                            x_quantity: x_quantity._0,
                                                                                                            x_market: x_market._0,
                                                                                                            x_alternative_markets: x_alternative_markets._0,
                                                                                                            x_last_modified_at: x_last_modified_at._0
                                                                                                          }
                                                                                                        };
                                                                                                }
                                                                                                var e = x_last_modified_at._0;
                                                                                                return {
                                                                                                        TAG: /* Error */1,
                                                                                                        _0: {
                                                                                                          path: ".x_last_modified_at" + e.path,
                                                                                                          message: e.message,
                                                                                                          value: e.value
                                                                                                        }
                                                                                                      };
                                                                                              }
                                                                                              var e$1 = x_alternative_markets._0;
                                                                                              return {
                                                                                                      TAG: /* Error */1,
                                                                                                      _0: {
                                                                                                        path: ".x_alternative_markets" + e$1.path,
                                                                                                        message: e$1.message,
                                                                                                        value: e$1.value
                                                                                                      }
                                                                                                    };
                                                                                            }
                                                                                            var e$2 = x_market._0;
                                                                                            return {
                                                                                                    TAG: /* Error */1,
                                                                                                    _0: {
                                                                                                      path: ".x_market" + e$2.path,
                                                                                                      message: e$2.message,
                                                                                                      value: e$2.value
                                                                                                    }
                                                                                                  };
                                                                                          }
                                                                                          var e$3 = x_quantity._0;
                                                                                          return {
                                                                                                  TAG: /* Error */1,
                                                                                                  _0: {
                                                                                                    path: ".x_quantity" + e$3.path,
                                                                                                    message: e$3.message,
                                                                                                    value: e$3.value
                                                                                                  }
                                                                                                };
                                                                                        }
                                                                                        var e$4 = x_tags._0;
                                                                                        return {
                                                                                                TAG: /* Error */1,
                                                                                                _0: {
                                                                                                  path: ".x_tags" + e$4.path,
                                                                                                  message: e$4.message,
                                                                                                  value: e$4.value
                                                                                                }
                                                                                              };
                                                                                      }
                                                                                      var e$5 = x_options._0;
                                                                                      return {
                                                                                              TAG: /* Error */1,
                                                                                              _0: {
                                                                                                path: ".x_options" + e$5.path,
                                                                                                message: e$5.message,
                                                                                                value: e$5.value
                                                                                              }
                                                                                            };
                                                                                    }
                                                                                    var e$6 = x_meta._0;
                                                                                    return {
                                                                                            TAG: /* Error */1,
                                                                                            _0: {
                                                                                              path: ".x_meta" + e$6.path,
                                                                                              message: e$6.message,
                                                                                              value: e$6.value
                                                                                            }
                                                                                          };
                                                                                  }
                                                                                  var e$7 = x_promo_text._0;
                                                                                  return {
                                                                                          TAG: /* Error */1,
                                                                                          _0: {
                                                                                            path: ".x_promo_text" + e$7.path,
                                                                                            message: e$7.message,
                                                                                            value: e$7.value
                                                                                          }
                                                                                        };
                                                                                }
                                                                                var e$8 = x_reviews_count._0;
                                                                                return {
                                                                                        TAG: /* Error */1,
                                                                                        _0: {
                                                                                          path: ".x_reviews_count" + e$8.path,
                                                                                          message: e$8.message,
                                                                                          value: e$8.value
                                                                                        }
                                                                                      };
                                                                              }
                                                                              var e$9 = x_reviews_average._0;
                                                                              return {
                                                                                      TAG: /* Error */1,
                                                                                      _0: {
                                                                                        path: ".x_reviews_average" + e$9.path,
                                                                                        message: e$9.message,
                                                                                        value: e$9.value
                                                                                      }
                                                                                    };
                                                                            }
                                                                            var e$10 = x_featured_rank._0;
                                                                            return {
                                                                                    TAG: /* Error */1,
                                                                                    _0: {
                                                                                      path: ".x_featured_rank" + e$10.path,
                                                                                      message: e$10.message,
                                                                                      value: e$10.value
                                                                                    }
                                                                                  };
                                                                          }
                                                                          var e$11 = x_best_seller_rank._0;
                                                                          return {
                                                                                  TAG: /* Error */1,
                                                                                  _0: {
                                                                                    path: ".x_best_seller_rank" + e$11.path,
                                                                                    message: e$11.message,
                                                                                    value: e$11.value
                                                                                  }
                                                                                };
                                                                        }
                                                                        var e$12 = x_created_at._0;
                                                                        return {
                                                                                TAG: /* Error */1,
                                                                                _0: {
                                                                                  path: ".x_created_at" + e$12.path,
                                                                                  message: e$12.message,
                                                                                  value: e$12.value
                                                                                }
                                                                              };
                                                                      }
                                                                      var e$13 = secondary__availability._0;
                                                                      return {
                                                                              TAG: /* Error */1,
                                                                              _0: {
                                                                                path: ".secondary__availability" + e$13.path,
                                                                                message: e$13.message,
                                                                                value: e$13.value
                                                                              }
                                                                            };
                                                                    }
                                                                    var e$14 = secondary__sale_price._0;
                                                                    return {
                                                                            TAG: /* Error */1,
                                                                            _0: {
                                                                              path: ".secondary__sale_price" + e$14.path,
                                                                              message: e$14.message,
                                                                              value: e$14.value
                                                                            }
                                                                          };
                                                                  }
                                                                  var e$15 = secondary__price._0;
                                                                  return {
                                                                          TAG: /* Error */1,
                                                                          _0: {
                                                                            path: ".secondary__price" + e$15.path,
                                                                            message: e$15.message,
                                                                            value: e$15.value
                                                                          }
                                                                        };
                                                                }
                                                                var e$16 = sku._0;
                                                                return {
                                                                        TAG: /* Error */1,
                                                                        _0: {
                                                                          path: ".sku" + e$16.path,
                                                                          message: e$16.message,
                                                                          value: e$16.value
                                                                        }
                                                                      };
                                                              }
                                                              var e$17 = mpn._0;
                                                              return {
                                                                      TAG: /* Error */1,
                                                                      _0: {
                                                                        path: ".mpn" + e$17.path,
                                                                        message: e$17.message,
                                                                        value: e$17.value
                                                                      }
                                                                    };
                                                            }
                                                            var e$18 = brand._0;
                                                            return {
                                                                    TAG: /* Error */1,
                                                                    _0: {
                                                                      path: ".brand" + e$18.path,
                                                                      message: e$18.message,
                                                                      value: e$18.value
                                                                    }
                                                                  };
                                                          }
                                                          var e$19 = link._0;
                                                          return {
                                                                  TAG: /* Error */1,
                                                                  _0: {
                                                                    path: ".link" + e$19.path,
                                                                    message: e$19.message,
                                                                    value: e$19.value
                                                                  }
                                                                };
                                                        }
                                                        var e$20 = availability._0;
                                                        return {
                                                                TAG: /* Error */1,
                                                                _0: {
                                                                  path: ".availability" + e$20.path,
                                                                  message: e$20.message,
                                                                  value: e$20.value
                                                                }
                                                              };
                                                      }
                                                      var e$21 = sane_product_type._0;
                                                      return {
                                                              TAG: /* Error */1,
                                                              _0: {
                                                                path: ".sane_product_type" + e$21.path,
                                                                message: e$21.message,
                                                                value: e$21.value
                                                              }
                                                            };
                                                    }
                                                    var e$22 = product_type._0;
                                                    return {
                                                            TAG: /* Error */1,
                                                            _0: {
                                                              path: ".product_type" + e$22.path,
                                                              message: e$22.message,
                                                              value: e$22.value
                                                            }
                                                          };
                                                  }
                                                  var e$23 = google_product_category._0;
                                                  return {
                                                          TAG: /* Error */1,
                                                          _0: {
                                                            path: ".google_product_category" + e$23.path,
                                                            message: e$23.message,
                                                            value: e$23.value
                                                          }
                                                        };
                                                }
                                                var e$24 = custom_label_9._0;
                                                return {
                                                        TAG: /* Error */1,
                                                        _0: {
                                                          path: ".custom_label_9" + e$24.path,
                                                          message: e$24.message,
                                                          value: e$24.value
                                                        }
                                                      };
                                              }
                                              var e$25 = custom_label_8._0;
                                              return {
                                                      TAG: /* Error */1,
                                                      _0: {
                                                        path: ".custom_label_8" + e$25.path,
                                                        message: e$25.message,
                                                        value: e$25.value
                                                      }
                                                    };
                                            }
                                            var e$26 = custom_label_7._0;
                                            return {
                                                    TAG: /* Error */1,
                                                    _0: {
                                                      path: ".custom_label_7" + e$26.path,
                                                      message: e$26.message,
                                                      value: e$26.value
                                                    }
                                                  };
                                          }
                                          var e$27 = custom_label_6._0;
                                          return {
                                                  TAG: /* Error */1,
                                                  _0: {
                                                    path: ".custom_label_6" + e$27.path,
                                                    message: e$27.message,
                                                    value: e$27.value
                                                  }
                                                };
                                        }
                                        var e$28 = custom_label_5._0;
                                        return {
                                                TAG: /* Error */1,
                                                _0: {
                                                  path: ".custom_label_5" + e$28.path,
                                                  message: e$28.message,
                                                  value: e$28.value
                                                }
                                              };
                                      }
                                      var e$29 = custom_label_4._0;
                                      return {
                                              TAG: /* Error */1,
                                              _0: {
                                                path: ".custom_label_4" + e$29.path,
                                                message: e$29.message,
                                                value: e$29.value
                                              }
                                            };
                                    }
                                    var e$30 = custom_label_3._0;
                                    return {
                                            TAG: /* Error */1,
                                            _0: {
                                              path: ".custom_label_3" + e$30.path,
                                              message: e$30.message,
                                              value: e$30.value
                                            }
                                          };
                                  }
                                  var e$31 = custom_label_2._0;
                                  return {
                                          TAG: /* Error */1,
                                          _0: {
                                            path: ".custom_label_2" + e$31.path,
                                            message: e$31.message,
                                            value: e$31.value
                                          }
                                        };
                                }
                                var e$32 = custom_label_1._0;
                                return {
                                        TAG: /* Error */1,
                                        _0: {
                                          path: ".custom_label_1" + e$32.path,
                                          message: e$32.message,
                                          value: e$32.value
                                        }
                                      };
                              }
                              var e$33 = custom_label_0._0;
                              return {
                                      TAG: /* Error */1,
                                      _0: {
                                        path: ".custom_label_0" + e$33.path,
                                        message: e$33.message,
                                        value: e$33.value
                                      }
                                    };
                            }
                            var e$34 = additional_image_link._0;
                            return {
                                    TAG: /* Error */1,
                                    _0: {
                                      path: ".additional_image_link" + e$34.path,
                                      message: e$34.message,
                                      value: e$34.value
                                    }
                                  };
                          }
                          var e$35 = image_link._0;
                          return {
                                  TAG: /* Error */1,
                                  _0: {
                                    path: ".image_link" + e$35.path,
                                    message: e$35.message,
                                    value: e$35.value
                                  }
                                };
                        }
                        var e$36 = item_group_id._0;
                        return {
                                TAG: /* Error */1,
                                _0: {
                                  path: ".item_group_id" + e$36.path,
                                  message: e$36.message,
                                  value: e$36.value
                                }
                              };
                      }
                      var e$37 = description._0;
                      return {
                              TAG: /* Error */1,
                              _0: {
                                path: ".description" + e$37.path,
                                message: e$37.message,
                                value: e$37.value
                              }
                            };
                    }
                    var e$38 = sale_price._0;
                    return {
                            TAG: /* Error */1,
                            _0: {
                              path: ".sale_price" + e$38.path,
                              message: e$38.message,
                              value: e$38.value
                            }
                          };
                  }
                  var e$39 = price._0;
                  return {
                          TAG: /* Error */1,
                          _0: {
                            path: ".price" + e$39.path,
                            message: e$39.message,
                            value: e$39.value
                          }
                        };
                }
                var e$40 = shape._0;
                return {
                        TAG: /* Error */1,
                        _0: {
                          path: ".shape" + e$40.path,
                          message: e$40.message,
                          value: e$40.value
                        }
                      };
              }
              var e$41 = style._0;
              return {
                      TAG: /* Error */1,
                      _0: {
                        path: ".style" + e$41.path,
                        message: e$41.message,
                        value: e$41.value
                      }
                    };
            }
            var e$42 = material._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: ".material" + e$42.path,
                      message: e$42.message,
                      value: e$42.value
                    }
                  };
          }
          var e$43 = pattern._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".pattern" + e$43.path,
                    message: e$43.message,
                    value: e$43.value
                  }
                };
        }
        var e$44 = color._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".color" + e$44.path,
                  message: e$44.message,
                  value: e$44.value
                }
              };
      }
      var e$45 = size._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".size" + e$45.path,
                message: e$45.message,
                value: e$45.value
              }
            };
    }
    var e$46 = title._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".title" + e$46.path,
              message: e$46.message,
              value: e$46.value
            }
          };
  }
  var e$47 = id._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".id" + e$47.path,
            message: e$47.message,
            value: e$47.value
          }
        };
}

var codec = [
  t_encode,
  t_decode
];

function t_encode$1(v) {
  return Js_dict.fromArray([
              [
                "itemGroupId",
                Curry._1(ItemGroupId.t_encode, v.itemGroupId)
              ],
              [
                "lastModifiedAt",
                Decco.optionToJson(Decco.floatToJson, v.lastModifiedAt)
              ]
            ]);
}

function t_decode$1(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var itemGroupId = Curry._1(ItemGroupId.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "itemGroupId"), null));
  if (itemGroupId.TAG === /* Ok */0) {
    var lastModifiedAt = Decco.optionFromJson(Decco.floatFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "lastModifiedAt"), null));
    if (lastModifiedAt.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                itemGroupId: itemGroupId._0,
                lastModifiedAt: lastModifiedAt._0
              }
            };
    }
    var e = lastModifiedAt._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".lastModifiedAt" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = itemGroupId._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".itemGroupId" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function t_encode$2(v) {
  return Js_dict.fromArray([
              [
                "next",
                Decco.optionToJson(Decco.stringToJson, v.next)
              ],
              [
                "entries",
                Decco.arrayToJson(t_encode$1, v.entries)
              ]
            ]);
}

function t_decode$2(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var next = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "next"), null));
  if (next.TAG === /* Ok */0) {
    var entries = Decco.arrayFromJson(t_decode$1, Belt_Option.getWithDefault(Js_dict.get(dict$1, "entries"), null));
    if (entries.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                next: next._0,
                entries: entries._0
              }
            };
    }
    var e = entries._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".entries" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = next._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".next" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

var codec$1 = [
  t_encode$2,
  t_decode$2
];

var Page = {
  t_encode: t_encode$2,
  t_decode: t_decode$2,
  codec: codec$1,
  toJson: t_encode$2,
  fromJson: t_decode$2
};

function t_encode$3(v) {
  return Decco.arrayToJson(t_encode$1, v);
}

function t_decode$3(v) {
  return Decco.arrayFromJson(t_decode$1, v);
}

var codec$2 = [
  t_encode$3,
  t_decode$3
];

var $$Array = {
  t_encode: t_encode$3,
  t_decode: t_decode$3,
  codec: codec$2,
  toJson: t_encode$3,
  fromJson: t_decode$3
};

var Listing = {
  t_encode: t_encode$1,
  t_decode: t_decode$1,
  Page: Page,
  $$Array: $$Array
};

function t_encode$4(v) {
  return Js_dict.fromArray([
              [
                "next",
                Decco.optionToJson(Decco.stringToJson, v.next)
              ],
              [
                "products",
                Decco.arrayToJson(t_encode, v.products)
              ]
            ]);
}

function t_decode$4(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var next = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "next"), null));
  if (next.TAG === /* Ok */0) {
    var products = Decco.arrayFromJson(t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "products"), null));
    if (products.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                next: next._0,
                products: products._0
              }
            };
    }
    var e = products._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".products" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = next._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".next" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

var codec$3 = [
  t_encode$4,
  t_decode$4
];

var Page$1 = {
  t_encode: t_encode$4,
  t_decode: t_decode$4,
  codec: codec$3,
  toJson: t_encode$4,
  fromJson: t_decode$4
};

function t_encode$5(v) {
  return Decco.arrayToJson(t_encode, v);
}

function t_decode$5(v) {
  return Decco.arrayFromJson(t_decode, v);
}

var codec$4 = [
  t_encode$5,
  t_decode$5
];

var $$Array$1 = {
  t_encode: t_encode$5,
  t_decode: t_decode$5,
  codec: codec$4,
  toJson: t_encode$5,
  fromJson: t_decode$5
};

function result_encode(encoder_a, v) {
  return Js_dict.fromArray([
              [
                "initialValue",
                Decco.optionToJson(Decco.stringToJson, v.initialValue)
              ],
              [
                "finalValue",
                Decco.resultToJson(encoder_a, Decco.stringToJson, v.finalValue)
              ],
              [
                "warnings",
                Decco.arrayToJson(Decco.stringToJson, v.warnings)
              ]
            ]);
}

function result_decode(decoder_a, v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var initialValue = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "initialValue"), null));
  if (initialValue.TAG === /* Ok */0) {
    var finalValue = Decco.resultFromJson(decoder_a, Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "finalValue"), null));
    if (finalValue.TAG === /* Ok */0) {
      var warnings = Decco.arrayFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "warnings"), null));
      if (warnings.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  initialValue: initialValue._0,
                  finalValue: finalValue._0,
                  warnings: warnings._0
                }
              };
      }
      var e = warnings._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".warnings" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = finalValue._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".finalValue" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = initialValue._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".initialValue" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

function mapFinalValue(result, fn) {
  var value = result.finalValue;
  var tmp;
  tmp = value.TAG === /* Ok */0 ? ({
        TAG: /* Ok */0,
        _0: Curry._1(fn, value._0)
      }) : ({
        TAG: /* Error */1,
        _0: value._0
      });
  return {
          initialValue: result.initialValue,
          finalValue: tmp,
          warnings: result.warnings
        };
}

var Validation = {
  result_encode: result_encode,
  result_decode: result_decode,
  mapFinalValue: mapFinalValue
};

var finalproduct_encode = t_encode;

var finalproduct_decode = t_decode;

function t_encode$6(v) {
  return Js_dict.fromArray([
              [
                "x_created_at",
                result_encode((function (param) {
                        return Decco.optionToJson(Decco.floatToJson, param);
                      }), v.x_created_at)
              ],
              [
                "x_best_seller_rank",
                result_encode((function (param) {
                        return Decco.optionToJson(Decco.floatToJson, param);
                      }), v.x_best_seller_rank)
              ],
              [
                "x_featured_rank",
                result_encode((function (param) {
                        return Decco.optionToJson(Decco.floatToJson, param);
                      }), v.x_featured_rank)
              ],
              [
                "x_reviews_average",
                result_encode((function (param) {
                        return Decco.optionToJson(Decco.floatToJson, param);
                      }), v.x_reviews_average)
              ],
              [
                "x_reviews_count",
                result_encode((function (param) {
                        return Decco.optionToJson(Decco.floatToJson, param);
                      }), v.x_reviews_count)
              ],
              [
                "x_promo_text",
                result_encode((function (param) {
                        return Decco.optionToJson(Decco.stringToJson, param);
                      }), v.x_promo_text)
              ],
              [
                "x_tags",
                result_encode((function (param) {
                        return Decco.optionToJson((function (param) {
                                      return Decco.arrayToJson(Decco.stringToJson, param);
                                    }), param);
                      }), v.x_tags)
              ],
              [
                "x_quantity",
                result_encode((function (param) {
                        return Decco.optionToJson(Decco.floatToJson, param);
                      }), v.x_quantity)
              ],
              [
                "x_meta",
                Decco.optionToJson((function (param) {
                        return Decco.dictToJson(Decco.stringToJson, param);
                      }), v.x_meta)
              ],
              [
                "x_options",
                Decco.optionToJson((function (param) {
                        return Decco.dictToJson(Decco.stringToJson, param);
                      }), v.x_options)
              ]
            ]);
}

function t_decode$6(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var x_created_at = result_decode((function (param) {
          return Decco.optionFromJson(Decco.floatFromJson, param);
        }), Belt_Option.getWithDefault(Js_dict.get(dict$1, "x_created_at"), null));
  if (x_created_at.TAG === /* Ok */0) {
    var x_best_seller_rank = result_decode((function (param) {
            return Decco.optionFromJson(Decco.floatFromJson, param);
          }), Belt_Option.getWithDefault(Js_dict.get(dict$1, "x_best_seller_rank"), null));
    if (x_best_seller_rank.TAG === /* Ok */0) {
      var x_featured_rank = result_decode((function (param) {
              return Decco.optionFromJson(Decco.floatFromJson, param);
            }), Belt_Option.getWithDefault(Js_dict.get(dict$1, "x_featured_rank"), null));
      if (x_featured_rank.TAG === /* Ok */0) {
        var x_reviews_average = result_decode((function (param) {
                return Decco.optionFromJson(Decco.floatFromJson, param);
              }), Belt_Option.getWithDefault(Js_dict.get(dict$1, "x_reviews_average"), null));
        if (x_reviews_average.TAG === /* Ok */0) {
          var x_reviews_count = result_decode((function (param) {
                  return Decco.optionFromJson(Decco.floatFromJson, param);
                }), Belt_Option.getWithDefault(Js_dict.get(dict$1, "x_reviews_count"), null));
          if (x_reviews_count.TAG === /* Ok */0) {
            var x_promo_text = result_decode((function (param) {
                    return Decco.optionFromJson(Decco.stringFromJson, param);
                  }), Belt_Option.getWithDefault(Js_dict.get(dict$1, "x_promo_text"), null));
            if (x_promo_text.TAG === /* Ok */0) {
              var x_tags = result_decode((function (param) {
                      return Decco.optionFromJson((function (param) {
                                    return Decco.arrayFromJson(Decco.stringFromJson, param);
                                  }), param);
                    }), Belt_Option.getWithDefault(Js_dict.get(dict$1, "x_tags"), null));
              if (x_tags.TAG === /* Ok */0) {
                var x_quantity = result_decode((function (param) {
                        return Decco.optionFromJson(Decco.floatFromJson, param);
                      }), Belt_Option.getWithDefault(Js_dict.get(dict$1, "x_quantity"), null));
                if (x_quantity.TAG === /* Ok */0) {
                  var x_meta = Decco.optionFromJson((function (param) {
                          return Decco.dictFromJson(Decco.stringFromJson, param);
                        }), Belt_Option.getWithDefault(Js_dict.get(dict$1, "x_meta"), null));
                  if (x_meta.TAG === /* Ok */0) {
                    var x_options = Decco.optionFromJson((function (param) {
                            return Decco.dictFromJson(Decco.stringFromJson, param);
                          }), Belt_Option.getWithDefault(Js_dict.get(dict$1, "x_options"), null));
                    if (x_options.TAG === /* Ok */0) {
                      return {
                              TAG: /* Ok */0,
                              _0: {
                                x_created_at: x_created_at._0,
                                x_best_seller_rank: x_best_seller_rank._0,
                                x_featured_rank: x_featured_rank._0,
                                x_reviews_average: x_reviews_average._0,
                                x_reviews_count: x_reviews_count._0,
                                x_promo_text: x_promo_text._0,
                                x_tags: x_tags._0,
                                x_quantity: x_quantity._0,
                                x_meta: x_meta._0,
                                x_options: x_options._0
                              }
                            };
                    }
                    var e = x_options._0;
                    return {
                            TAG: /* Error */1,
                            _0: {
                              path: ".x_options" + e.path,
                              message: e.message,
                              value: e.value
                            }
                          };
                  }
                  var e$1 = x_meta._0;
                  return {
                          TAG: /* Error */1,
                          _0: {
                            path: ".x_meta" + e$1.path,
                            message: e$1.message,
                            value: e$1.value
                          }
                        };
                }
                var e$2 = x_quantity._0;
                return {
                        TAG: /* Error */1,
                        _0: {
                          path: ".x_quantity" + e$2.path,
                          message: e$2.message,
                          value: e$2.value
                        }
                      };
              }
              var e$3 = x_tags._0;
              return {
                      TAG: /* Error */1,
                      _0: {
                        path: ".x_tags" + e$3.path,
                        message: e$3.message,
                        value: e$3.value
                      }
                    };
            }
            var e$4 = x_promo_text._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: ".x_promo_text" + e$4.path,
                      message: e$4.message,
                      value: e$4.value
                    }
                  };
          }
          var e$5 = x_reviews_count._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".x_reviews_count" + e$5.path,
                    message: e$5.message,
                    value: e$5.value
                  }
                };
        }
        var e$6 = x_reviews_average._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".x_reviews_average" + e$6.path,
                  message: e$6.message,
                  value: e$6.value
                }
              };
      }
      var e$7 = x_featured_rank._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".x_featured_rank" + e$7.path,
                message: e$7.message,
                value: e$7.value
              }
            };
    }
    var e$8 = x_best_seller_rank._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".x_best_seller_rank" + e$8.path,
              message: e$8.message,
              value: e$8.value
            }
          };
  }
  var e$9 = x_created_at._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".x_created_at" + e$9.path,
            message: e$9.message,
            value: e$9.value
          }
        };
}

var CustomLabelExtensions = {
  t_encode: t_encode$6,
  t_decode: t_decode$6
};

function t_encode$7(v) {
  return Js_dict.fromArray([
              [
                "google_feed_id",
                result_encode(Id.t_encode, v.google_feed_id)
              ],
              [
                "title",
                result_encode((function (param) {
                        return Decco.optionToJson(Decco.stringToJson, param);
                      }), v.title)
              ],
              [
                "size",
                result_encode((function (param) {
                        return Decco.optionToJson(Decco.stringToJson, param);
                      }), v.size)
              ],
              [
                "color",
                result_encode((function (param) {
                        return Decco.optionToJson(Decco.stringToJson, param);
                      }), v.color)
              ],
              [
                "pattern",
                result_encode((function (param) {
                        return Decco.optionToJson(Decco.stringToJson, param);
                      }), v.pattern)
              ],
              [
                "material",
                result_encode((function (param) {
                        return Decco.optionToJson(Decco.stringToJson, param);
                      }), v.material)
              ],
              [
                "style",
                result_encode((function (param) {
                        return Decco.optionToJson(Decco.stringToJson, param);
                      }), v.style)
              ],
              [
                "shape",
                result_encode((function (param) {
                        return Decco.optionToJson(Decco.stringToJson, param);
                      }), v.shape)
              ],
              [
                "price",
                result_encode((function (param) {
                        return Decco.optionToJson(Money$FeedSync.t_encode, param);
                      }), v.price)
              ],
              [
                "sale_price",
                result_encode((function (param) {
                        return Decco.optionToJson(Money$FeedSync.t_encode, param);
                      }), v.sale_price)
              ],
              [
                "description",
                result_encode((function (param) {
                        return Decco.optionToJson(Decco.stringToJson, param);
                      }), v.description)
              ],
              [
                "item_group_id",
                result_encode(ItemGroupId.t_encode, v.item_group_id)
              ],
              [
                "image_link",
                result_encode((function (param) {
                        return Decco.optionToJson(Decco.stringToJson, param);
                      }), v.image_link)
              ],
              [
                "additional_image_link",
                result_encode((function (param) {
                        return Decco.optionToJson(Decco.stringToJson, param);
                      }), v.additional_image_link)
              ],
              [
                "custom_label_0",
                result_encode((function (param) {
                        return Decco.optionToJson(t_encode$6, param);
                      }), v.custom_label_0)
              ],
              [
                "custom_label_1",
                result_encode((function (param) {
                        return Decco.optionToJson(t_encode$6, param);
                      }), v.custom_label_1)
              ],
              [
                "custom_label_2",
                result_encode((function (param) {
                        return Decco.optionToJson(t_encode$6, param);
                      }), v.custom_label_2)
              ],
              [
                "custom_label_3",
                result_encode((function (param) {
                        return Decco.optionToJson(t_encode$6, param);
                      }), v.custom_label_3)
              ],
              [
                "custom_label_4",
                result_encode((function (param) {
                        return Decco.optionToJson(t_encode$6, param);
                      }), v.custom_label_4)
              ],
              [
                "custom_label_5",
                result_encode((function (param) {
                        return Decco.optionToJson(t_encode$6, param);
                      }), v.custom_label_5)
              ],
              [
                "custom_label_6",
                result_encode((function (param) {
                        return Decco.optionToJson(t_encode$6, param);
                      }), v.custom_label_6)
              ],
              [
                "custom_label_7",
                result_encode((function (param) {
                        return Decco.optionToJson(t_encode$6, param);
                      }), v.custom_label_7)
              ],
              [
                "custom_label_8",
                result_encode((function (param) {
                        return Decco.optionToJson(t_encode$6, param);
                      }), v.custom_label_8)
              ],
              [
                "custom_label_9",
                result_encode((function (param) {
                        return Decco.optionToJson(t_encode$6, param);
                      }), v.custom_label_9)
              ],
              [
                "google_product_category",
                result_encode((function (param) {
                        return Decco.optionToJson(Decco.stringToJson, param);
                      }), v.google_product_category)
              ],
              [
                "product_type",
                result_encode((function (param) {
                        return Decco.optionToJson((function (param) {
                                      return Decco.arrayToJson(Decco.stringToJson, param);
                                    }), param);
                      }), v.product_type)
              ],
              [
                "availability",
                result_encode(Decco.stringToJson, v.availability)
              ],
              [
                "link",
                result_encode((function (param) {
                        return Decco.optionToJson(Decco.stringToJson, param);
                      }), v.link)
              ],
              [
                "brand",
                result_encode((function (param) {
                        return Decco.optionToJson(Decco.stringToJson, param);
                      }), v.brand)
              ],
              [
                "mpn",
                result_encode((function (param) {
                        return Decco.optionToJson(Decco.stringToJson, param);
                      }), v.mpn)
              ],
              [
                "sku",
                result_encode((function (param) {
                        return Decco.optionToJson(Decco.stringToJson, param);
                      }), v.sku)
              ],
              [
                "extensions",
                result_encode((function (param) {
                        return Decco.optionToJson(t_encode$6, param);
                      }), v.extensions)
              ]
            ]);
}

function t_decode$7(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var google_feed_id = result_decode(Id.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "google_feed_id"), null));
  if (google_feed_id.TAG === /* Ok */0) {
    var title = result_decode((function (param) {
            return Decco.optionFromJson(Decco.stringFromJson, param);
          }), Belt_Option.getWithDefault(Js_dict.get(dict$1, "title"), null));
    if (title.TAG === /* Ok */0) {
      var size = result_decode((function (param) {
              return Decco.optionFromJson(Decco.stringFromJson, param);
            }), Belt_Option.getWithDefault(Js_dict.get(dict$1, "size"), null));
      if (size.TAG === /* Ok */0) {
        var color = result_decode((function (param) {
                return Decco.optionFromJson(Decco.stringFromJson, param);
              }), Belt_Option.getWithDefault(Js_dict.get(dict$1, "color"), null));
        if (color.TAG === /* Ok */0) {
          var pattern = result_decode((function (param) {
                  return Decco.optionFromJson(Decco.stringFromJson, param);
                }), Belt_Option.getWithDefault(Js_dict.get(dict$1, "pattern"), null));
          if (pattern.TAG === /* Ok */0) {
            var material = result_decode((function (param) {
                    return Decco.optionFromJson(Decco.stringFromJson, param);
                  }), Belt_Option.getWithDefault(Js_dict.get(dict$1, "material"), null));
            if (material.TAG === /* Ok */0) {
              var style = result_decode((function (param) {
                      return Decco.optionFromJson(Decco.stringFromJson, param);
                    }), Belt_Option.getWithDefault(Js_dict.get(dict$1, "style"), null));
              if (style.TAG === /* Ok */0) {
                var shape = result_decode((function (param) {
                        return Decco.optionFromJson(Decco.stringFromJson, param);
                      }), Belt_Option.getWithDefault(Js_dict.get(dict$1, "shape"), null));
                if (shape.TAG === /* Ok */0) {
                  var price = result_decode((function (param) {
                          return Decco.optionFromJson(Money$FeedSync.t_decode, param);
                        }), Belt_Option.getWithDefault(Js_dict.get(dict$1, "price"), null));
                  if (price.TAG === /* Ok */0) {
                    var sale_price = result_decode((function (param) {
                            return Decco.optionFromJson(Money$FeedSync.t_decode, param);
                          }), Belt_Option.getWithDefault(Js_dict.get(dict$1, "sale_price"), null));
                    if (sale_price.TAG === /* Ok */0) {
                      var description = result_decode((function (param) {
                              return Decco.optionFromJson(Decco.stringFromJson, param);
                            }), Belt_Option.getWithDefault(Js_dict.get(dict$1, "description"), null));
                      if (description.TAG === /* Ok */0) {
                        var item_group_id = result_decode(ItemGroupId.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "item_group_id"), null));
                        if (item_group_id.TAG === /* Ok */0) {
                          var image_link = result_decode((function (param) {
                                  return Decco.optionFromJson(Decco.stringFromJson, param);
                                }), Belt_Option.getWithDefault(Js_dict.get(dict$1, "image_link"), null));
                          if (image_link.TAG === /* Ok */0) {
                            var additional_image_link = result_decode((function (param) {
                                    return Decco.optionFromJson(Decco.stringFromJson, param);
                                  }), Belt_Option.getWithDefault(Js_dict.get(dict$1, "additional_image_link"), null));
                            if (additional_image_link.TAG === /* Ok */0) {
                              var custom_label_0 = result_decode((function (param) {
                                      return Decco.optionFromJson(t_decode$6, param);
                                    }), Belt_Option.getWithDefault(Js_dict.get(dict$1, "custom_label_0"), null));
                              if (custom_label_0.TAG === /* Ok */0) {
                                var custom_label_1 = result_decode((function (param) {
                                        return Decco.optionFromJson(t_decode$6, param);
                                      }), Belt_Option.getWithDefault(Js_dict.get(dict$1, "custom_label_1"), null));
                                if (custom_label_1.TAG === /* Ok */0) {
                                  var custom_label_2 = result_decode((function (param) {
                                          return Decco.optionFromJson(t_decode$6, param);
                                        }), Belt_Option.getWithDefault(Js_dict.get(dict$1, "custom_label_2"), null));
                                  if (custom_label_2.TAG === /* Ok */0) {
                                    var custom_label_3 = result_decode((function (param) {
                                            return Decco.optionFromJson(t_decode$6, param);
                                          }), Belt_Option.getWithDefault(Js_dict.get(dict$1, "custom_label_3"), null));
                                    if (custom_label_3.TAG === /* Ok */0) {
                                      var custom_label_4 = result_decode((function (param) {
                                              return Decco.optionFromJson(t_decode$6, param);
                                            }), Belt_Option.getWithDefault(Js_dict.get(dict$1, "custom_label_4"), null));
                                      if (custom_label_4.TAG === /* Ok */0) {
                                        var custom_label_5 = result_decode((function (param) {
                                                return Decco.optionFromJson(t_decode$6, param);
                                              }), Belt_Option.getWithDefault(Js_dict.get(dict$1, "custom_label_5"), null));
                                        if (custom_label_5.TAG === /* Ok */0) {
                                          var custom_label_6 = result_decode((function (param) {
                                                  return Decco.optionFromJson(t_decode$6, param);
                                                }), Belt_Option.getWithDefault(Js_dict.get(dict$1, "custom_label_6"), null));
                                          if (custom_label_6.TAG === /* Ok */0) {
                                            var custom_label_7 = result_decode((function (param) {
                                                    return Decco.optionFromJson(t_decode$6, param);
                                                  }), Belt_Option.getWithDefault(Js_dict.get(dict$1, "custom_label_7"), null));
                                            if (custom_label_7.TAG === /* Ok */0) {
                                              var custom_label_8 = result_decode((function (param) {
                                                      return Decco.optionFromJson(t_decode$6, param);
                                                    }), Belt_Option.getWithDefault(Js_dict.get(dict$1, "custom_label_8"), null));
                                              if (custom_label_8.TAG === /* Ok */0) {
                                                var custom_label_9 = result_decode((function (param) {
                                                        return Decco.optionFromJson(t_decode$6, param);
                                                      }), Belt_Option.getWithDefault(Js_dict.get(dict$1, "custom_label_9"), null));
                                                if (custom_label_9.TAG === /* Ok */0) {
                                                  var google_product_category = result_decode((function (param) {
                                                          return Decco.optionFromJson(Decco.stringFromJson, param);
                                                        }), Belt_Option.getWithDefault(Js_dict.get(dict$1, "google_product_category"), null));
                                                  if (google_product_category.TAG === /* Ok */0) {
                                                    var product_type = result_decode((function (param) {
                                                            return Decco.optionFromJson((function (param) {
                                                                          return Decco.arrayFromJson(Decco.stringFromJson, param);
                                                                        }), param);
                                                          }), Belt_Option.getWithDefault(Js_dict.get(dict$1, "product_type"), null));
                                                    if (product_type.TAG === /* Ok */0) {
                                                      var availability = result_decode(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "availability"), null));
                                                      if (availability.TAG === /* Ok */0) {
                                                        var link = result_decode((function (param) {
                                                                return Decco.optionFromJson(Decco.stringFromJson, param);
                                                              }), Belt_Option.getWithDefault(Js_dict.get(dict$1, "link"), null));
                                                        if (link.TAG === /* Ok */0) {
                                                          var brand = result_decode((function (param) {
                                                                  return Decco.optionFromJson(Decco.stringFromJson, param);
                                                                }), Belt_Option.getWithDefault(Js_dict.get(dict$1, "brand"), null));
                                                          if (brand.TAG === /* Ok */0) {
                                                            var mpn = result_decode((function (param) {
                                                                    return Decco.optionFromJson(Decco.stringFromJson, param);
                                                                  }), Belt_Option.getWithDefault(Js_dict.get(dict$1, "mpn"), null));
                                                            if (mpn.TAG === /* Ok */0) {
                                                              var sku = result_decode((function (param) {
                                                                      return Decco.optionFromJson(Decco.stringFromJson, param);
                                                                    }), Belt_Option.getWithDefault(Js_dict.get(dict$1, "sku"), null));
                                                              if (sku.TAG === /* Ok */0) {
                                                                var extensions = result_decode((function (param) {
                                                                        return Decco.optionFromJson(t_decode$6, param);
                                                                      }), Belt_Option.getWithDefault(Js_dict.get(dict$1, "extensions"), null));
                                                                if (extensions.TAG === /* Ok */0) {
                                                                  return {
                                                                          TAG: /* Ok */0,
                                                                          _0: {
                                                                            google_feed_id: google_feed_id._0,
                                                                            title: title._0,
                                                                            size: size._0,
                                                                            color: color._0,
                                                                            pattern: pattern._0,
                                                                            material: material._0,
                                                                            style: style._0,
                                                                            shape: shape._0,
                                                                            price: price._0,
                                                                            sale_price: sale_price._0,
                                                                            description: description._0,
                                                                            item_group_id: item_group_id._0,
                                                                            image_link: image_link._0,
                                                                            additional_image_link: additional_image_link._0,
                                                                            custom_label_0: custom_label_0._0,
                                                                            custom_label_1: custom_label_1._0,
                                                                            custom_label_2: custom_label_2._0,
                                                                            custom_label_3: custom_label_3._0,
                                                                            custom_label_4: custom_label_4._0,
                                                                            custom_label_5: custom_label_5._0,
                                                                            custom_label_6: custom_label_6._0,
                                                                            custom_label_7: custom_label_7._0,
                                                                            custom_label_8: custom_label_8._0,
                                                                            custom_label_9: custom_label_9._0,
                                                                            google_product_category: google_product_category._0,
                                                                            product_type: product_type._0,
                                                                            availability: availability._0,
                                                                            link: link._0,
                                                                            brand: brand._0,
                                                                            mpn: mpn._0,
                                                                            sku: sku._0,
                                                                            extensions: extensions._0
                                                                          }
                                                                        };
                                                                }
                                                                var e = extensions._0;
                                                                return {
                                                                        TAG: /* Error */1,
                                                                        _0: {
                                                                          path: ".extensions" + e.path,
                                                                          message: e.message,
                                                                          value: e.value
                                                                        }
                                                                      };
                                                              }
                                                              var e$1 = sku._0;
                                                              return {
                                                                      TAG: /* Error */1,
                                                                      _0: {
                                                                        path: ".sku" + e$1.path,
                                                                        message: e$1.message,
                                                                        value: e$1.value
                                                                      }
                                                                    };
                                                            }
                                                            var e$2 = mpn._0;
                                                            return {
                                                                    TAG: /* Error */1,
                                                                    _0: {
                                                                      path: ".mpn" + e$2.path,
                                                                      message: e$2.message,
                                                                      value: e$2.value
                                                                    }
                                                                  };
                                                          }
                                                          var e$3 = brand._0;
                                                          return {
                                                                  TAG: /* Error */1,
                                                                  _0: {
                                                                    path: ".brand" + e$3.path,
                                                                    message: e$3.message,
                                                                    value: e$3.value
                                                                  }
                                                                };
                                                        }
                                                        var e$4 = link._0;
                                                        return {
                                                                TAG: /* Error */1,
                                                                _0: {
                                                                  path: ".link" + e$4.path,
                                                                  message: e$4.message,
                                                                  value: e$4.value
                                                                }
                                                              };
                                                      }
                                                      var e$5 = availability._0;
                                                      return {
                                                              TAG: /* Error */1,
                                                              _0: {
                                                                path: ".availability" + e$5.path,
                                                                message: e$5.message,
                                                                value: e$5.value
                                                              }
                                                            };
                                                    }
                                                    var e$6 = product_type._0;
                                                    return {
                                                            TAG: /* Error */1,
                                                            _0: {
                                                              path: ".product_type" + e$6.path,
                                                              message: e$6.message,
                                                              value: e$6.value
                                                            }
                                                          };
                                                  }
                                                  var e$7 = google_product_category._0;
                                                  return {
                                                          TAG: /* Error */1,
                                                          _0: {
                                                            path: ".google_product_category" + e$7.path,
                                                            message: e$7.message,
                                                            value: e$7.value
                                                          }
                                                        };
                                                }
                                                var e$8 = custom_label_9._0;
                                                return {
                                                        TAG: /* Error */1,
                                                        _0: {
                                                          path: ".custom_label_9" + e$8.path,
                                                          message: e$8.message,
                                                          value: e$8.value
                                                        }
                                                      };
                                              }
                                              var e$9 = custom_label_8._0;
                                              return {
                                                      TAG: /* Error */1,
                                                      _0: {
                                                        path: ".custom_label_8" + e$9.path,
                                                        message: e$9.message,
                                                        value: e$9.value
                                                      }
                                                    };
                                            }
                                            var e$10 = custom_label_7._0;
                                            return {
                                                    TAG: /* Error */1,
                                                    _0: {
                                                      path: ".custom_label_7" + e$10.path,
                                                      message: e$10.message,
                                                      value: e$10.value
                                                    }
                                                  };
                                          }
                                          var e$11 = custom_label_6._0;
                                          return {
                                                  TAG: /* Error */1,
                                                  _0: {
                                                    path: ".custom_label_6" + e$11.path,
                                                    message: e$11.message,
                                                    value: e$11.value
                                                  }
                                                };
                                        }
                                        var e$12 = custom_label_5._0;
                                        return {
                                                TAG: /* Error */1,
                                                _0: {
                                                  path: ".custom_label_5" + e$12.path,
                                                  message: e$12.message,
                                                  value: e$12.value
                                                }
                                              };
                                      }
                                      var e$13 = custom_label_4._0;
                                      return {
                                              TAG: /* Error */1,
                                              _0: {
                                                path: ".custom_label_4" + e$13.path,
                                                message: e$13.message,
                                                value: e$13.value
                                              }
                                            };
                                    }
                                    var e$14 = custom_label_3._0;
                                    return {
                                            TAG: /* Error */1,
                                            _0: {
                                              path: ".custom_label_3" + e$14.path,
                                              message: e$14.message,
                                              value: e$14.value
                                            }
                                          };
                                  }
                                  var e$15 = custom_label_2._0;
                                  return {
                                          TAG: /* Error */1,
                                          _0: {
                                            path: ".custom_label_2" + e$15.path,
                                            message: e$15.message,
                                            value: e$15.value
                                          }
                                        };
                                }
                                var e$16 = custom_label_1._0;
                                return {
                                        TAG: /* Error */1,
                                        _0: {
                                          path: ".custom_label_1" + e$16.path,
                                          message: e$16.message,
                                          value: e$16.value
                                        }
                                      };
                              }
                              var e$17 = custom_label_0._0;
                              return {
                                      TAG: /* Error */1,
                                      _0: {
                                        path: ".custom_label_0" + e$17.path,
                                        message: e$17.message,
                                        value: e$17.value
                                      }
                                    };
                            }
                            var e$18 = additional_image_link._0;
                            return {
                                    TAG: /* Error */1,
                                    _0: {
                                      path: ".additional_image_link" + e$18.path,
                                      message: e$18.message,
                                      value: e$18.value
                                    }
                                  };
                          }
                          var e$19 = image_link._0;
                          return {
                                  TAG: /* Error */1,
                                  _0: {
                                    path: ".image_link" + e$19.path,
                                    message: e$19.message,
                                    value: e$19.value
                                  }
                                };
                        }
                        var e$20 = item_group_id._0;
                        return {
                                TAG: /* Error */1,
                                _0: {
                                  path: ".item_group_id" + e$20.path,
                                  message: e$20.message,
                                  value: e$20.value
                                }
                              };
                      }
                      var e$21 = description._0;
                      return {
                              TAG: /* Error */1,
                              _0: {
                                path: ".description" + e$21.path,
                                message: e$21.message,
                                value: e$21.value
                              }
                            };
                    }
                    var e$22 = sale_price._0;
                    return {
                            TAG: /* Error */1,
                            _0: {
                              path: ".sale_price" + e$22.path,
                              message: e$22.message,
                              value: e$22.value
                            }
                          };
                  }
                  var e$23 = price._0;
                  return {
                          TAG: /* Error */1,
                          _0: {
                            path: ".price" + e$23.path,
                            message: e$23.message,
                            value: e$23.value
                          }
                        };
                }
                var e$24 = shape._0;
                return {
                        TAG: /* Error */1,
                        _0: {
                          path: ".shape" + e$24.path,
                          message: e$24.message,
                          value: e$24.value
                        }
                      };
              }
              var e$25 = style._0;
              return {
                      TAG: /* Error */1,
                      _0: {
                        path: ".style" + e$25.path,
                        message: e$25.message,
                        value: e$25.value
                      }
                    };
            }
            var e$26 = material._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: ".material" + e$26.path,
                      message: e$26.message,
                      value: e$26.value
                    }
                  };
          }
          var e$27 = pattern._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".pattern" + e$27.path,
                    message: e$27.message,
                    value: e$27.value
                  }
                };
        }
        var e$28 = color._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".color" + e$28.path,
                  message: e$28.message,
                  value: e$28.value
                }
              };
      }
      var e$29 = size._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".size" + e$29.path,
                message: e$29.message,
                value: e$29.value
              }
            };
    }
    var e$30 = title._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".title" + e$30.path,
              message: e$30.message,
              value: e$30.value
            }
          };
  }
  var e$31 = google_feed_id._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".google_feed_id" + e$31.path,
            message: e$31.message,
            value: e$31.value
          }
        };
}

function t_encode$8(v) {
  if (v.TAG === /* Accepted */0) {
    return [
            "Accepted",
            t_encode(v._0),
            t_encode$7(v._1)
          ];
  } else {
    return [
            "Rejected",
            Decco.stringToJson(v._0),
            Decco.optionToJson(t_encode$7, v._1)
          ];
  }
}

function t_decode$8(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = Js_array.map(Js_json.classify, jsonArr$1);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "Accepted" :
          if (tagged.length !== 3) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$1 = t_decode(Belt_Array.getExn(jsonArr$1, 1));
          var match$2 = t_decode$7(Belt_Array.getExn(jsonArr$1, 2));
          if (match$1.TAG === /* Ok */0) {
            if (match$2.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        TAG: /* Accepted */0,
                        _0: match$1._0,
                        _1: match$2._0
                      }
                    };
            }
            var e = match$2._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e.path,
                      message: e.message,
                      value: e.value
                    }
                  };
          }
          var e$1 = match$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
      case "Rejected" :
          if (tagged.length !== 3) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$3 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
          var match$4 = Decco.optionFromJson(t_decode$7, Belt_Array.getExn(jsonArr$1, 2));
          if (match$3.TAG === /* Ok */0) {
            if (match$4.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        TAG: /* Rejected */1,
                        _0: match$3._0,
                        _1: match$4._0
                      }
                    };
            }
            var e$2 = match$4._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e$2.path,
                      message: e$2.message,
                      value: e$2.value
                    }
                  };
          }
          var e$3 = match$3._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$3.path,
                    message: e$3.message,
                    value: e$3.value
                  }
                };
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function t_encode$9(v) {
  return Decco.arrayToJson(t_encode$8, v);
}

function t_decode$9(v) {
  return Decco.arrayFromJson(t_decode$8, v);
}

var codec$5 = [
  t_encode$9,
  t_decode$9
];

var $$Array$2 = {
  t_encode: t_encode$9,
  t_decode: t_decode$9,
  codec: codec$5,
  toJson: t_encode$9,
  fromJson: t_decode$9
};

function t_encode$10(v) {
  return Js_dict.fromArray([
              [
                "next",
                Decco.optionToJson(Decco.stringToJson, v.next)
              ],
              [
                "products",
                Decco.arrayToJson(t_encode$8, v.products)
              ]
            ]);
}

function t_decode$10(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var next = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "next"), null));
  if (next.TAG === /* Ok */0) {
    var products = Decco.arrayFromJson(t_decode$8, Belt_Option.getWithDefault(Js_dict.get(dict$1, "products"), null));
    if (products.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                next: next._0,
                products: products._0
              }
            };
    }
    var e = products._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".products" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = next._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".next" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

var codec$6 = [
  t_encode$10,
  t_decode$10
];

var Page$2 = {
  t_encode: t_encode$10,
  t_decode: t_decode$10,
  codec: codec$6,
  toJson: t_encode$10,
  fromJson: t_decode$10
};

var Result = {
  t_encode: t_encode$8,
  t_decode: t_decode$8,
  $$Array: $$Array$2,
  Page: Page$2
};

var Validated = {
  finalproduct_encode: finalproduct_encode,
  finalproduct_decode: finalproduct_decode,
  CustomLabelExtensions: CustomLabelExtensions,
  t_encode: t_encode$7,
  t_decode: t_decode$7,
  Result: Result
};

var toJson = t_encode;

var fromJson = t_decode;

export {
  Id ,
  ItemGroupId ,
  t_dirty_encode ,
  t_dirty_decode ,
  t_encode ,
  t_decode ,
  codec ,
  toJson ,
  fromJson ,
  Listing ,
  Page$1 as Page,
  $$Array$1 as $$Array,
  Validation ,
  Validated ,
}
/* Id Not a pure module */
